<template>
  <a-card :bordered="false">
    <div style="margin-bottom: 20px">
      <a-row>
        <a-col :span="19"></a-col>
        <a-col :span="5" :style="{ textAlign: 'right' }">
          <a-button v-if="editEnabel" type="primary" icon="plus" @click="$refs.modal.add()">新增</a-button>
          <!--<a-dropdown v-if="removeEnable&&selectedRowKeys.length > 0">-->
          <!--<a-button type="danger" icon="delete" style="width: 120px;" @click="delByIds(selectedRowKeys)">删除</a-button>-->
          <!--</a-dropdown>-->
        </a-col>
      </a-row>
    </div>
    <s-table
      size="default"
      ref="table"
      rowKey="channelId"
      :columns="columns"
      :data="loadData"
      bordered
    >
      <!--<span slot="installationType" slot-scope="text, record">-->
         <!--<td v-for="type in restaurantTypes" :key="type.code" v-if="record.installationType == type.code">{{type.label}}</td>-->
      <!--</span>-->
      <span slot="isBack" slot-scope="text, record">
        {{ text | remindFilter }}
      </span>
      <span slot="isMust" slot-scope="text, record">
        {{ text | remindFilter }}
      </span>
      <span slot="fieldType" slot-scope="text, record">
        {{ text | fieldFilter }}
      </span>
      <span slot="fieldValue" slot-scope="text, record">
         <td v-for="type in data1" :key="type.dictType" v-if="record.fieldValue == type.dictType">{{type.dictName}}</td>
      </span>
      <span slot="action" slot-scope="text, record">
        <a v-if="queryList" @click="handleEdit(record,1)">查看</a>
        <a-divider v-if="queryList" type="vertical"/>
        <a v-if="editEnabel" @click="handleEdit(record)">编辑</a>
        <a-divider v-if="deleteEnable && editEnabel" type="vertical"/>
        <a v-if="deleteEnable" @click="delByIds(record.id)">删除</a>
        <a-divider v-if="deleteEnable" type="vertical" />
        <span v-if="editEnabel">
          <a v-if="record.forbidden==1" @click="showState(record.id,record.forbidden)">启用</a>
          <a v-else @click="showState(record.id,record.forbidden)">禁用</a>
        </span>
      </span>
    </s-table>
    <channel-modal ref="modal" @ok="handleOk"/>
  </a-card>
</template>
<script>

  import { STable } from '@/components'
  import { getInfoList,remove,getList,remindMap,fieldType } from '@/api/basicdatas/Orderinstallinfo'
  import ChannelModal from './modules/OrderinstaModal.vue'
  import { checkPermission } from '@/utils/permissions'
  import {getDictMap} from "../../utils/dict"

  export default {
    name: 'TableList',
    components: {
      STable,
      ChannelModal
    },
    data () {
      return {
        form: this.$form.createForm(this),
        mdl: {},
        // 高级搜索 展开/关闭
        advanced: false,
        // 查询参数
        queryParam: {},
        // 表头
        columns: [
          {
            title: '序号',
            dataIndex: 'sort',
            align:'center',
          },
          {
            title: '操作',
            width:60,
            dataIndex: 'action',
            scopedSlots: { customRender: 'action' },
          },
          {
            title: '安装信息',
            dataIndex: 'installationInfoName',
            align:'center'
          },
          {
            title: '字段类型',
            dataIndex: 'fieldType',
            scopedSlots: { customRender: 'fieldType' },
            align:'center'
          },
          {
            title: '字段取值',
            dataIndex: 'fieldValue',
            scopedSlots: { customRender: 'fieldValue' },
            align:'center'
          },
          {
            title: '是否回传',
            dataIndex: 'isBack',
            scopedSlots: { customRender: 'isBack' },
            align:'center'
          },
          {
            title: '是否必填',
            dataIndex: 'isMust',
            scopedSlots: { customRender: 'isMust' },
            align:'center'
          },
          {
            title: '最近修改时间',
            dataIndex: 'updateTime',
            align:'center'
          },
          {
            title: '操作人',
            dataIndex: 'updateBy',
            align:'center'
          }
        ],
        // 加载数据方法 必须为 Promise 对象
        loadData: parameter => {
          let data = getInfoList(Object.assign(parameter, this.queryParam))
          return data
        },
        data:[],
        data1:[],
        // restaurantTypes: [],
        restaurantTypes1: [],
        remindMap,
        fieldType,
        editEnabel: checkPermission('basicdata:orderinstallinfo:edit'),
        deleteEnable: checkPermission('basicdata:orderinstallinfo:delete'),
        queryList: checkPermission('basicdata:orderinstallinfo:query'),
      }
    },
    filters: {
      remindFilter (value) {
        return remindMap[value]
      },
      fieldFilter (value) {
        return fieldType[value]
      },
    },
    async created () {
      // this.restaurantTypes = [];
      this.restaurantTypes1 = [];
      // this.restaurantOperTypeMap = await getDictMap('install_type');
      this.restaurantOperTypeMap1 = await getDictMap('SMART_LOCK');
      // this.restaurantOperTypeMap.forEach((value, key) => {
      //   // console.log(value,key)
      //   this.restaurantTypes.push({code: key, label: value})
      // })
      this.restaurantOperTypeMap1.forEach((value, key) => {
        // console.log(value,key)
        this.restaurantTypes1.push({code: key, label: value})
      })
      getList().then(res=>{
        this.data1=res.rows
      })
    },
    methods: {
      // handleBlur() {
      //   // console.log('blur');
      // },
      // handleFocus() {
      //   // console.log('focus');
      // },
      filterOption(input, option) {
        return (
          option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
        );
      },
      handleChange (value) {
        // console.log(`selected ${value}`)
        this.queryParam.enterpriseId= value
      },
      showState (id, forbidden) {
        if (forbidden == 0) {
          remove({ 'id': id,'isForbidden':1 }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('禁用成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        } else if (forbidden == 1) {
          remove({ 'id': id,'isForbidden':0 }).then(res => {
            // console.log(res)
            if (res.code === 0) {
              this.$message.success('启动成功')
              this.handleOk()
            } else {
              this.$message.error(res.msg)
            }
          })
        }
      },
      handleAdd () {
        this.$refs.modal.add()
      },
      handleEdit (record,status) {
        // console.log(record)
        this.$refs.modal.edit(record,status)
      },
      handleOk (value) {
        if(value == 1){
          this.$refs.table.refresh(true)
        }else{
          this.$refs.table.refresh()
        }
      },
      delByIds (id) {
        let that = this
        this.$confirm({
          title: '删除',
          content: '您确定删除本数据吗？',
          okType: 'danger',
          onOk() {
            remove({ 'id':id, 'delStatus': 1 }).then(res => {
              if (res.code === 0) {
                that.$message.success('删除成功')
                that.handleOk()
              } else {
                that.$message.error(res.msg)
              }
            })
          },
          onCancel() {
            console.log('Cancel');
          },
        });
      }
    },
    watch: {
      /*
          'selectedRows': function (selectedRows) {
            this.needTotalList = this.needTotalList.map(item => {
              return {
                ...item,
                total: selectedRows.reduce( (sum, val) => {
                  return sum + val[item.dataIndex]
                }, 0)
              }
            })
          }
          */
    }
  }
</script>
<style scoped>
  /deep/ .ant-table th { white-space: nowrap; }
  /deep/ .ant-table td { white-space: nowrap; padding: 4px 16px;}
</style>